import React from 'react';
import { styled, keyframes } from '@mui/system';
import Box from '@mui/material/Box';
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";

const checkmarkAnimation = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const SuccessBox = styled(Box)(() => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--green1)',
    color: 'white',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    animation: `${checkmarkAnimation} 0.6s ease-out`,
}));

const SuccessMessage = ({ message }) => {
    return (
        <SuccessBox>
            <CheckCircleIcon style={{ fontSize: 48, marginRight: 8 }} />
            {message}
        </SuccessBox>
    );
};

export default SuccessMessage;
